
<template>
  <div>
    <show-execution></show-execution>
  </div>  
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'PageShowExecution',
  components: {
    ShowExecution: () => import('@/components/_execution/show/ShowExecution.vue'),
  },
  data() {
    return {
      
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>